export default {
    reload: "Refresh",
    add: "Add a line",
    edit: "'Edit a string' mode",
    delete: "Delete",
    copy: "Copy a line",
    download: "Export",
    upload: "Import",
    styles: "Cells color",
    columns: "Visible columns",
    "view-fields": "Visible columns",
    "unit-marine-map": "Unit marine map",
    filters: "Filters",
    attach: "Attach a document",
    history: "Change history",
    trash: "Recycle bin",
    fullRemove: "Delete permanently",
    rowsLength: "Line quantity in table",
    restore: "Restore",
    "choose-row": "Choose a line",
    "tree-table": "Dendritic mode",
    showCapitalAccountForm: "Edit in form",
    AccountRemainsIconView: "Account balance",
    "tree-toggle-all": "Minimaze all/Maximize all",
    "copy-delivery": "Create a copy",
    import: "Import",
    task: "Set a task",
    manageAssistants: "Appoint/Delete assistants",
    manageEmployees: "Appoint/Delete employees",
    manageManagers: "Appoint/Remove managers",
    manageRoles: "Appoint/Remove roles",
    export: "Download",
    export2: "Download",
    changeLog: "Data change log",
    clone: "Copy",
    cloneCompanyCrm: "Copy",
    clonePaymentOrder: "Copy",
    "unit-map": "The cargo on the map",
    showUnitFormByLogistas: "Form",
    "create-combiner": "Create shipment",
    showOwnerUnitMap: "Show map",
    chat: "Chat",
    reports: "Reports",
    CreateInvoicesByFinOpers: "Create invoice",
    IssueInvoiceByFinOpers: "Issue invoice",
    CapitalOperationsByObject: "Transactions",
    CreateGtdInvoice: "Create invoice with reference to Customs Declaration",
    ShowPreviewDynamicJournal: "Open magazine"
};
